import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'checkout-ticket-tooltip',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './ticket-tooltip.component.html',
})
export class TicketTooltipComponent {
    @Input() public popover: string;
    @Input() public dataTcCategory: string;
}
